export enum DisplayedCurrency {
  EUR = 'EUR',
  Local = 'Local'
}
